import { styled, Grid, lighten, IconButton, Dialog } from "@mui/material";

export const AddButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  width: "150px",
  fontSize: "30px",
  borderRadius: "5px",
}));

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "25px",
  gap: "15px",
});

export const DragNDropContainer = styled(Grid, { shouldForwardProp: (prop) => prop !== "isDragging" })<{
  isDragging: boolean;
}>(
  ({ theme }) => ({
    // width : "400px",
    height: "150px",
    border: "1px dashed black",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.5s ease",
    "&:hover": {
      backgroundColor: `${lighten(theme.palette.primary.light, 0.6)}`,
      border: `2px dashed ${theme.palette.primary.light}`,
    },
  }),
  ({ isDragging, theme }) => ({
    ...(isDragging && {
      backgroundColor: `${lighten(theme.palette.primary.light, 0.6)}`,
      border: `2px dashed ${theme.palette.primary.light}`,
    }),
  })
);

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
